import AppColors from './../colors/AppColors';

export default class Strings {
    public static readonly APP_NAME = "Coin Chester";
    public static readonly STYLED_APP_NAME = `coin<span style="color:${AppColors.GREY_TEXT}">chester</span>`;
    public static readonly LOGIN_TEXT = "Login";
    public static readonly SIGNUP_TEXT = "Sign Up";
    public static readonly CREATE_ACCOUNT = "Create Account";
    public static readonly FEATURES = "Features";
    public static readonly ONBOARDING_MSG_1 = `Crypto for <b style='color:${AppColors.lightenOrDarken("#4caf50", 80)};'>Everyone</b>`;
    public static readonly ONBOARDING_MSG_2 = `${Strings.APP_NAME} is the most secure and trusted place to <b style='color:white;'>Multiply, Grow</b> and <b style='color:white;'>Win</b> bitcoins.`;
    public static readonly ONBOARDING_MSG_5 = "Win Free BTC";
    public static readonly ONBOARDING_MSG_6 = `Try your luck every hour and win up to <b style='color:white;'>$200</b> in free bitcoins!`
    public static readonly GET_STARTED = "Get Started";
    public static readonly PLEASE_WAIT = "Please wait...";
    public static readonly RECOVER_PASSWORD = "Recover Password";
    public static readonly SOURCE_CODE_STRING = 'import sha512 from \'crypto-js/sha512\';\n' +
        'import hmacSHA512 from \'crypto-js/hmac-sha512\';\n' +
        'import bigInt from "big-integer";\n' +
        '\n' +
        'function SHA512Digest(message) {\n' +
        '    return sha512(message).toString();\n' +
        '}\n' +
        '\n' +
        'function padHMAC512HashIfPossible(hash) {\n' +
        '    const max = 128\n' +
        '    const hashLength = hash.length\n' +
        '    const diff = max - hashLength\n' +
        '    if (diff > 0) {\n' +
        '        let missingPieces = [];\n' +
        '        for (let i = 0; i < diff; i++) {\n' +
        '            missingPieces.push("0")\n' +
        '        }\n' +
        '        return missingPieces.join("") + hash\n' +
        '    }\n' +
        '    return hash\n' +
        '}\n' +
        '\n' +
        'function HMAC512Digest(string1, string2) {\n' +
        '    return padHMAC512HashIfPossible(hmacSHA512(string1, string2).toString())\n' +
        '}\n' +
        '\n' +
        'function getNonZeroNumber(workingVal, radix) {\n' +
        '    let number = bigInt(workingVal).mod(radix);\n' +
        '    if (number.eq(bigInt(0))) {\n' +
        '        return number.add(bigInt(1));\n' +
        '    }\n' +
        '    return number;\n' +
        '}\n' +
        '\n' +
        '/**\n' +
        ' *\n' +
        ' * This function generates your Lucky Roll in the Free Roller\n' +
        ' * **/\n' +
        ' function generateLuckyNumber(serverSeed, clientSeed, nonce) {\n' +
        '    let string1 = `${nonce}:${serverSeed}:${nonce}`\n' +
        '    let string2 = `${nonce}:${clientSeed}:${nonce}`\n' +
        '    let HMAC512Hash = HMAC512Digest(string1, string2)\n' +
        '    let first8Chars = HMAC512Hash?.substring(0, 8)\n' +
        '    let decimal = parseInt(first8Chars, 16);\n' +
        '    let result = decimal / 429496.7295\n' +
        '    return Math.round(result)\n' +
        '}\n' +
        '\n' +
        '/**\n' +
        ' * This function generates your winning numbers in the 6/49 Game\n' +
        ' * **/function generateWinningNumbers(serverSeed, clientSeed, nonce) {\n' +
        '    let string1 = `${nonce}:${serverSeed}:${nonce}`;\n' +
        '    let string2 = `${nonce}:${clientSeed}:${nonce}`;\n' +
        '    let HMAC512Hash = HMAC512Digest(string1, string2);\n' +
        '    let first64Chars = HMAC512Hash.substring(0, 64)\n' +
        '    let workingVal = bigInt(first64Chars, 16, null, true)\n' +
        '    let radix = 50\n' +
        '    let dissolutionCounter = 6\n' +
        '    let winningNumbers = []\n' +
        '    do {\n' +
        '        let number = getNonZeroNumber(workingVal, radix)\n' +
        '        workingVal = workingVal.divide(bigInt(radix))\n' +
        '        if (!winningNumbers.includes(\'\' + number)) {\n' +
        '            winningNumbers.push(\'\' + number)\n' +
        '            dissolutionCounter--\n' +
        '        }\n' +
        '    } while (dissolutionCounter !== 0)\n' +
        '    return winningNumbers\n' +
        '}\n' +
        '\n' +
        '//To Check Your Lucky Roll\n' +
        'let myLuckyRoll = generateLuckyNumber("pass in your server seed","pass in your client seed","pass in your nonce");\n' +
        '//To Check your winning numbers\n' +
        'let winningNumbers = generateWinningNumbers("pass in your server seed","pass in your client seed","pass in your nonce")\n' +
        '\n' +
        '//To confirm if the SHA512 Hash of the Server Seed we shouwed you before the game play actually matches the final SHA512 after the game play\n' +
        'let finalSHA512Hash = SHA512Digest("pass in your server seed");\n' +
        'let initialSHA512Hash = "paste the one we showed you before the game play";\n' +
        'if(finalSHA512Hash.toLowerCase()===initialSHA512Hash.toLowerCase()){\n' +
        '    //Server Seeds Matched...So, the System never cheated you.\n' +
        '}\n' +
        '\n' +
        '//Welcome To ' + Strings.APP_NAME + ' and Goodluck with your games!!!';
}